import React from "react";

export const Quiz = () => {
  return (
    <>
      <p>Take our quiz!</p>
    </>
  );
};
